export default __webpack_public_path__ + "static/media/background.9a698fc5.jpg";